module.exports = __webpack_public_path__ + "media/images/icon-inquiry-line-2ce37946347fc4008e67ed1585e467a3.svg";